
        import {css} from 'lit-element';   
        export default css`sp-action-menu{display:flex;flex-flow:column nowrap;align-items:stretch}`;
    